import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const RawMaterialContext = createContext();

export const RawMaterialProvider = ({ children }) => {
  const [getData, setGetData] = useState(true)
  const [insumoPernil, setInsumoPernil] = useState({
    estoqueInicial: 0,
    precoMedio: 11.90,
    cobertura: 90,
    totalCompra: 0,
    prevVenda: 0,
    prevProducao: 0,
    quantidadeCompra: 0,
    unidadeMedida: "KG"
  });

  const [insumoFrangoLeve, setInsumoFrangoLeve] = useState({
    estoqueInicial: 0,
    precoMedio: 4.20,
    cobertura: 1,
    totalCompra: 0,
    prevVenda: 0,
    prevProducao: 0,
    quantidadeCompra: 0,
    unidadeMedida: "KG"
  });

  const [insumoFrangoPesado, setInsumoFrangoPesado] = useState({
    estoqueInicial: 0,
    precoMedio: 4.20,
    cobertura: 1,
    totalCompra: 0,
    prevVenda: 0,
    prevProducao: 0,
    quantidadeCompra: 0,
    unidadeMedida: "KG"
  });

  const [insumoBatata, setInsumoBatata] = useState({
    estoqueInicial: 0,
    precoMedio: 4.90,
    cobertura: 90,
    totalCompra: 0,
    prevVenda: 0,
    prevProducao: 0,
    quantidadeCompra: 0,
    unidadeMedida: "KG"
  });

  const [insumoSacola, setInsumoSacola] = useState({
    estoqueInicial: 0,
    precoMedio: 350,
    cobertura: 360,
    totalCompra: 0,
    prevVenda: 0,
    prevProducao: 0,
    quantidadeCompra: 0,
    unidadeMedida: "MILHEI"
  });

  const [insumoCondimentos, setInsumoCondimentos] = useState({
    estoqueInicial: 0,
    precoMedio: 95,
    cobertura: 90,
    totalCompra: 0,
    prevVenda: 0,
    prevProducao: 0,
    quantidadeCompra: 0,
    unidadeMedida: "KG"
  });

  const [insumoCaixa, setInsumoCaixa] = useState({
    estoqueInicial: 0,
    precoMedio: 1.85,
    cobertura: 90,
    totalCompra: 0,
    prevVenda: 0,
    prevProducao: 0,
    quantidadeCompra: 0,
    unidadeMedida: "Unidade(s)"
  });

  function getStockInsumo() {
    const storagedIndustry = JSON.parse(localStorage.getItem('@App:industria'));
    if (!storagedIndustry) return
    axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/estoqueInsumo/listarEstoqueIndustria/${storagedIndustry?.industria}`)
      .then(response => {
        response.data.forEach(element => {

          if (element.insumo.insumo === 4) {

            const data = insumoPernil
            data.estoqueInicial = element.quantidade
            setInsumoPernil(data)

          } else if (element.insumo.insumo === 5) {

            const data = insumoCaixa
            data.estoqueInicial = element.quantidade
            setInsumoCaixa(data)

          } else if (element.insumo.insumo === 6) {

            const data = insumoSacola
            data.estoqueInicial = element.quantidade
            setInsumoSacola(data)

          } else if (element.insumo.insumo === 7) {

            const data = insumoCondimentos
            data.estoqueInicial = element.quantidade
            setInsumoCondimentos(data)

          } else if (element.insumo.insumo === 8) {

            const data = insumoFrangoPesado
            data.estoqueInicial = element.quantidade
            setInsumoFrangoPesado(data)

          } else if (element.insumo.insumo === 9) {

            const data = insumoFrangoLeve
            data.estoqueInicial = element.quantidade
            setInsumoFrangoLeve(data)

          } else if (element.insumo.insumo === 10) {

            const data = insumoBatata
            data.estoqueInicial = element.quantidade
            setInsumoBatata(data)

          }

        });
      })

  }

  useEffect(() => {

    getStockInsumo()

  }, [])


  useEffect(() => {

    if (getData) {
      axios.get("https://sistemas.sisinfor.com.br/BusinessGameBack/api/produto/listarTodos")
        .then(response => {
          // const data = response.data[0]
          // console.log(response)
          // setInfoSausage({
          //   previsaoVendas: 0,
          //   estoque: data.estoque,
          //   previsaoProducao: 0,
          //   custoUnitario: data.custo,
          //   receitaProduto: infoSausage.receitaProduto,
          //   pesoCaixa: 4,
          // })
        })

      setGetData(false)
    }

    // setInfoSausage(infoSausage);

  }, [insumoPernil,
    insumoFrangoLeve,
    insumoFrangoPesado,
    insumoBatata,
    insumoSacola,
    insumoCondimentos,
    insumoCaixa,
    getData
  ]);


  return (
    <RawMaterialContext.Provider
      value={{
        insumoPernil,
        setInsumoPernil,
        insumoFrangoLeve,
        setInsumoFrangoLeve,
        insumoFrangoPesado,
        setInsumoFrangoPesado,
        insumoBatata,
        setInsumoBatata,
        insumoSacola,
        setInsumoSacola,
        insumoCondimentos,
        setInsumoCondimentos,
        insumoCaixa,
        setInsumoCaixa,
        getStockInsumo
      }}
    >
      {children}
    </RawMaterialContext.Provider>
  );
};

export const useRawMaterial = () => useContext(RawMaterialContext);
